import React from "react";
import {
  OurServices,
  // CoreServices,
  Feedback,
  MartleyNutshell,
  MBDClassic,
  NewsOffers,
  //Subscription,
  //Vouchers,
  MartleyNutshell2,
} from "components/_ui";
import { BizNeeds } from "components/_ui";
// import React,{lazy, Suspense} from "react";
import { Hero } from "../../_templates";
import "./index.scss";
import { useEffect } from "react";
// import { Footer } from "components/_templates";

// import { useStateSelector, useActionDispatch  } from "./hooks";
// import {useHistory,useParams} from 'react-router-dom';

// test
import { useLocation } from "react-router-dom"; // ← added: read current hash

const string =
  " |title-primary: Lorem ipsum dolor sit amet| consectetur adipisicing elit. Explicabo atque consequatur magni vero fugiat, reiciendis doloremque quidem, veniam magnam obcaecati maxime minus molestias ea provident beatae eaque consequuntur doloribus tenetur.";

const Homepage = () => {
  // ── handle hash scrolls (e.g., /#our-services) with header offset ─────────
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const id = location.hash.replace("#", "");
    const headerH =
      document.querySelector(".menu-bar")?.offsetHeight || 0;
    const extra = 20; // breathing room
    let tries = 0;

    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        const y =
          el.getBoundingClientRect().top +
          window.pageYOffset -
          headerH -
          extra;
        window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
        return;
      }
      // if the section hasn't mounted yet (lazy/AOS), retry briefly
      if (tries < 20) {
        tries += 1;
        setTimeout(tryScroll, 50);
      }
    };

    // wait a tick so the route/render finishes before measuring
    setTimeout(tryScroll, 0);
  }, [location.hash]);

  return (
    <div className="page home">
      <Hero />
      {/* <Vouchers /> */}
      {/* <Subscription /> */}
      {/* <CoreServices /> */}
      <div id="our-services" style={{ position: 'relative', top: '-1px' }} />
      <OurServices />
      <Feedback />
      <MBDClassic />
      <BizNeeds />
      <MartleyNutshell />
      <MartleyNutshell2 />
      <NewsOffers />
    </div>
  );
};

export default Homepage;
